export const getUserProfile = async (instance, accounts) => {
  const response = await instance.acquireTokenSilent({
    scopes: ["User.Read"],
    account: accounts[0],
  });

  const res = await fetch("https://graph.microsoft.com/v1.0/me", {
    headers: {
      Authorization: `Bearer ${response.accessToken}`,
    },
  });

  const profile = await res.json();
  return profile;
};